import { render } from "./locations.vue?vue&type=template&id=d8a4132e&scoped=true"
import script from "./locations.vue?vue&type=script&lang=js"
export * from "./locations.vue?vue&type=script&lang=js"

import "./locations.vue?vue&type=style&index=0&id=d8a4132e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a4132e"]])

export default __exports__